// Появление при скролле из edad: одиночные .anim-item и группы .anim-group.
// --no-hide оставляет элемент видимым после первого появления (см. anim.styl).
let observer = null
let edgeObserver = null
let targets = []
let resizeFrame = null

const isOnce = (el) => el.classList.contains('anim-item--no-hide') || el.classList.contains('anim-group--no-hide')

const collectTargets = () => {
	const groups = Array.from(document.querySelectorAll('.anim-group')).filter((el) => {
		const media = el.dataset.animGroupMedia
		const active = !media || window.matchMedia(media).matches
		el.classList.toggle('anim-group--inactive', !active)
		return active
	})
	const items = Array.from(document.querySelectorAll('.anim-item')).filter((el) => !groups.some((group) => group.contains(el)))
	return [...groups, ...items]
}

const show = (el) => {
	el.classList.add('is-visible')
	if (isOnce(el)) {
		// Сохраняем показанные элементы при переходе из группы к отдельным рядам
		if (el.classList.contains('anim-group')) {
			el.querySelectorAll('.anim-item').forEach((item) => item.classList.add('is-visible'))
		}
		if (observer) observer.unobserve(el)
		if (edgeObserver) edgeObserver.unobserve(el)
	}
}

const observeTargets = () => {
	if (observer) observer.disconnect()
	if (edgeObserver) edgeObserver.disconnect()
	targets = collectTargets()

	const onIntersect = (entries) => {
		entries.forEach((entry) => {
			const el = entry.target
			if (entry.isIntersecting) {
				show(el)
			} else if (!isOnce(el) && !el.contains(document.activeElement)) {
				el.classList.remove('is-visible')
			}
		})
	}
	const bottomMargin = Math.round(window.innerHeight * 0.2)
	observer = new IntersectionObserver(onIntersect, {
		// Триггер на 80% высоты экрана; пиксели сохраняют эту линию при любой ширине
		rootMargin: `0px 0px -${bottomMargin}px 0px`,
		threshold: 0,
	})
	// Короткие элементы у конца страницы не могут дойти до основной линии-триггера
	edgeObserver = new IntersectionObserver(onIntersect, { threshold: 0 })
	const lastTrigger = document.documentElement.scrollHeight - bottomMargin

	targets.forEach((el) => {
		if (isOnce(el) && el.classList.contains('is-visible')) return
		const top = el.getBoundingClientRect().top + window.scrollY
		const targetObserver = top >= lastTrigger ? edgeObserver : observer
		targetObserver.observe(el)
	})
}

const onResize = () => {
	if (!observer || resizeFrame !== null) return
	resizeFrame = window.requestAnimationFrame(() => {
		resizeFrame = null
		if (observer) observeTargets()
	})
}

const onFocus = (e) => {
	// Переход Tab не должен оставлять ссылку или кнопку невидимой
	targets.forEach((el) => {
		if (el.contains(e.target)) show(el)
	})
}

export function initReveal() {
	if (observer) observer.disconnect()
	if (edgeObserver) edgeObserver.disconnect()
	observer = null
	edgeObserver = null
	window.removeEventListener('resize', onResize)
	document.removeEventListener('focusin', onFocus)

	const root = document.body
	if (!root.classList.contains('anim-page')) {
		targets = []
		root.classList.remove('reveal-ready', 'reveal-initializing')
		return
	}
	targets = collectTargets()

	if (!targets.length || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		root.classList.remove('reveal-ready', 'reveal-initializing')
		targets.forEach(show)
		return
	}

	// Начальное скрытие без перехода; анимируем только последующее появление
	root.classList.add('reveal-ready', 'reveal-initializing')
	root.getBoundingClientRect()
	// Измеряем уже со сдвигом: короткие элементы у края страницы должны попасть в edgeObserver
	observeTargets()
	root.classList.remove('reveal-initializing')
	window.addEventListener('resize', onResize)
	document.addEventListener('focusin', onFocus)
}

// Повторный запуск, включая уже показанные элементы с --no-hide
export function resetReveal() {
	document.querySelectorAll('.anim-item, .anim-group').forEach((el) => el.classList.remove('is-visible'))
	initReveal()
}
